import React, { useState, useEffect } from 'react';
import './Quizeethon.css';
import C2wQuizeethonLanding from './landing/landing';
import C2wNavbar from '../../components/C2wNavbar/navbarIndex';
import Footer from '../c2wHomePage/Footer';

function C2wQuizeethon() {
  const [activeImage, setActiveImage] = useState(null);

  const quizImages = [
    { id: 1, src: '/assets/images/upcomingCourse/1_quiz.PNG', title: 'Rank 1' },
    { id: 2, src: '/assets/images/upcomingCourse/2_quiz.PNG', title: 'Rank 2' },
    { id: 3, src: '/assets/images/upcomingCourse/3_quiz.PNG', title: 'Rank 3' },
    { id: 4, src: '/assets/images/upcomingCourse/4_quiz.PNG', title: 'Rank 4' },
    { id: 5, src: '/assets/images/upcomingCourse/5_quiz.PNG', title: 'Rank 5' },
    { id: 6, src: '/assets/images/upcomingCourse/6_quiz.PNG', title: 'Rank 6' },
    { id: 7, src: '/assets/images/upcomingCourse/7_quiz.PNG', title: 'Rank 7' },
    { id: 8, src: '/assets/images/upcomingCourse/8_quiz.PNG', title: 'Rank 8' },
    { id: 9, src: '/assets/images/upcomingCourse/9_quiz.PNG', title: 'Rank 9' },
    { id: 10, src: '/assets/images/upcomingCourse/10_quiz.PNG', title: 'Rank 10' },
  ];

  const handlePrev = (e) => {
    if (e) e.stopPropagation();
    if (!activeImage) return;
    const currentIndex = quizImages.findIndex((img) => img.id === activeImage.id);
    const prevIndex = (currentIndex - 1 + quizImages.length) % quizImages.length;
    setActiveImage(quizImages[prevIndex]);
  };

  const handleNext = (e) => {
    if (e) e.stopPropagation();
    if (!activeImage) return;
    const currentIndex = quizImages.findIndex((img) => img.id === activeImage.id);
    const nextIndex = (currentIndex + 1) % quizImages.length;
    setActiveImage(quizImages[nextIndex]);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!activeImage) return;
      if (e.key === 'ArrowLeft') handlePrev();
      if (e.key === 'ArrowRight') handleNext();
      if (e.key === 'Escape') setActiveImage(null);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeImage]);

  return (
    <div className="C2wQuizeethon_ctn">
      <C2wNavbar />
      <C2wQuizeethonLanding />

      {/* Quizeethon Data Grid Section */}
      <section className="quizeethon-grid-section" id="quiz-grid">
        <div className="quizeethon-grid-container">
          {/* Grid Layout */}
          <div className="quizeethon-image-grid" id="quiz-image-grid-scroll">
            {quizImages.map((quiz) => (
              <div
                key={quiz.id}
                className="quizeethon-grid-card"
                onClick={() => setActiveImage(quiz)}
              >
                <div className="quizeethon-card-img-wrapper">
                  <img
                    src={quiz.src}
                    alt={quiz.title}
                    className="quizeethon-grid-img"
                    loading="lazy"
                  />
                  <div className="quizeethon-card-overlay">
                    <span className="material-symbols-outlined expand-icon">zoom_in</span>
                    <span>Click to Expand</span>
                  </div>
                </div>
                <div className="quizeethon-card-footer">
                  <span className="quiz-card-number">🏆 {quiz.title}</span>
                  <span className="quiz-card-title">Quizeethon Winner</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fullscreen Lightbox Modal with Forward & Backward Buttons */}
      {activeImage && (
        <div className="quizeethon-lightbox" onClick={() => setActiveImage(null)}>
          {/* Previous Button */}
          <button className="quizeethon-lightbox-nav prev" onClick={handlePrev} title="Previous Winner (Rank)">
            <span className="material-symbols-outlined">arrow_back_ios</span>
          </button>

          <div className="quizeethon-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="quizeethon-lightbox-close" onClick={() => setActiveImage(null)}>
              ✕
            </button>
            <img src={activeImage.src} alt={activeImage.title} className="quizeethon-lightbox-img" />
            <div className="quizeethon-lightbox-caption">
              <span>🏆 {activeImage.title} - Quizeethon Winner</span>
              <span className="lightbox-step-info">({quizImages.findIndex(img => img.id === activeImage.id) + 1} of {quizImages.length})</span>
            </div>
          </div>

          {/* Next Button */}
          <button className="quizeethon-lightbox-nav next" onClick={handleNext} title="Next Winner (Rank)">
            <span className="material-symbols-outlined">arrow_forward_ios</span>
          </button>
        </div>
      )}

      <div className="ADfooter__container" style={{ width: '100%' }}>
        <Footer />
      </div>
    </div>
  );
}

export default C2wQuizeethon;
